import React, { forwardRef } from 'react'
import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';

import { NavLink, NavLinkProps } from 'react-router-dom';
import { useRouter } from 'hooks';

export interface AppMenuItemComponentProps {
  className?: string,
  open: boolean,
  name: string,
  link?: string | null, // because the InferProps props allows alows null value
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

const AppMenuItemComponent: React.FC<AppMenuItemComponentProps> = props => {
  const { className, onClick, link, children, name, open } = props
  const router = useRouter();

  // If link is not set return the orinary ListItem
  if (!link || typeof link !== 'string') {
    return (
      <Tooltip title={name} disableHoverListener={open} disableTouchListener={open}>
        <ListItem
          button
          className={className}
          children={children}
          onClick={onClick}
          style={open ? {} : { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0' }}
        />
      </Tooltip>
    )
  }

  // Return a LitItem with a link component
  return (
    <Tooltip title={name} disableHoverListener={open} disableTouchListener={open}>
      <ListItem
        onClick={onClick}
        button
        className={className}
        children={children}
        selected={router.pathname.indexOf(link) !== -1 ? true : false}
        component={forwardRef((props: NavLinkProps, ref: any) => <NavLink exact {...props} innerRef={ref} />)}
        to={link}
        style={open ? {} : { display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0' }}
      />
    </Tooltip>
  )
}

export default AppMenuItemComponent
